import { injectable } from "inversify";
import "reflect-metadata";

import { DIID } from "@archipad-js/dependency-injection";
import { IllegalArgumentError } from "@core/errors/errors-core";

import { LOG_AS_STORAGE_KEY } from "./legacy-account.service";

export const User_Session_Storage_Service_DIID = DIID<UserSessionStorageService>("UserSessionStorageService");

/**
 * [PLUS-158] Delete this service and all is usages
 * A re-implementation of legacy's `window.name` storage using `window.sessionStorage`.
 * It should support node and lack of `window`.
 */
@injectable()
export class UserSessionStorageService {
    constructor(private readonly targetWindow: Window = window ) {
        if (typeof this.targetWindow !== "object" || !this.targetWindow.sessionStorage ) {
            throw new IllegalArgumentError("Could not find sessionStorage on current window. UserSessionStorageService should only be used in browser scope.");
        }
    }

    public store(key: string, value: string): void {
        this.targetWindow.sessionStorage.setItem(key, value);
    }

    public get(key: string): string | null {
        return this.targetWindow.sessionStorage.getItem(key);
    }

    public remove(key: string): void {
        this.targetWindow.sessionStorage.removeItem(key);
    }

    public storeLogAs(logAs: string): void {
        this.store(LOG_AS_STORAGE_KEY, logAs);
    }

    public getStoredLogAs(): string | null {
        return this.get(LOG_AS_STORAGE_KEY);
    }

    public clearLogAs(): void {
        this.remove(LOG_AS_STORAGE_KEY);
    }
}
